"use client";

import React from "react";
import EditSection, { TextEditor, ListItemEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function UniversityEventsEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  const defaultEvents = [
    { title: "Edu Fest 2023: Igniting Minds, Transforming Lives", date: "Nov 11, 2023", location: "Yarra Park, UK", link: "#" },
    { title: "Sustainability & Development Showcase: Green Living", date: "Nov 11, 2023", location: "Yarra Park, UK", link: "#" },
    { title: "Career Carnival: Explore Your Professional Journey", date: "Nov 11, 2023", location: "Yarra Park, UK", link: "#" },
  ];

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Headers</h4>
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Campus Events"
            />
            <TextEditor
              label="Subtitle"
              value={content.subtitle}
              onChange={(v) => handleChange({ ...content, subtitle: v })}
              placeholder="Join our upcoming university events..."
            />
            <TextEditor
              label="View All Link URL"
              value={content.viewAllLink || ""}
              onChange={(v) => handleChange({ ...content, viewAllLink: v })}
              placeholder="#"
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Events List</h4>
            <ListItemEditor
              label="Events"
              items={content.events || defaultEvents}
              itemSchema={[
                { key: "title", label: "Event Title", type: "text" },
                { key: "date", label: "Date / Time", type: "text" },
                { key: "location", label: "Location", type: "text" },
                { key: "link", label: "Link URL", type: "text" },
              ]}
              onChange={(items) => handleChange({ ...content, events: items })}
              addItemText="Add Event"
            />
          </div>
        </div>
      }
    />
  );
}
